document.addEventListener("DOMContentLoaded", function () {
  var navItems = Array.prototype.slice.call(document.querySelectorAll("[data-app-nav]"));
  var sections = Array.prototype.slice.call(document.querySelectorAll("[data-app-section]"));
  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (navItems.length && sections.length) {
    var nav = document.querySelector(".apps-page__nav-track") || document.querySelector(".apps-page__nav");
    var stickyNav = document.querySelector(".apps-page__nav");
    var navIndicator = null;
    var activeSectionId = "";
    var programmaticScrollUntil = 0;
    var syncFrame = null;

    function getStickyNavOffset() {
      var stickyTop;

      if (!stickyNav || !window.matchMedia("(max-width: 991px)").matches) {
        return 0;
      }

      stickyTop = parseFloat(getComputedStyle(stickyNav).top) || 0;
      return stickyNav.offsetHeight + stickyTop + 16;
    }

    function getScrollOffset(target) {
      var marginTop = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      var stickyOffset = getStickyNavOffset();
      return Math.max(0, target.getBoundingClientRect().top + window.scrollY - Math.max(marginTop, stickyOffset));
    }

    function getTapNavCenterBehavior() {
      if (reducedMotion) {
        return "auto";
      }

      return window.matchMedia("(max-width: 991px)").matches ? "smooth" : "auto";
    }

    function ensureNavIndicator() {
      if (!nav) {
        return;
      }

      nav.classList.add("has-nav-indicator");
      navIndicator = nav.querySelector(".apps-page__nav-indicator");

      if (!navIndicator) {
        navIndicator = document.createElement("span");
        navIndicator.className = "apps-page__nav-indicator";
        nav.insertBefore(navIndicator, nav.firstChild);
      }
    }

    function getNavItemForSectionId(sectionId) {
      var matchingItem = null;

      navItems.some(function (item) {
        var targetId = item.getAttribute("href").replace(/^#/, "");

        if (targetId === sectionId) {
          matchingItem = item;
          return true;
        }

        return false;
      });

      return matchingItem;
    }

    function getNavIndicatorInset() {
      return parseFloat(getComputedStyle(nav).getPropertyValue("--apps-nav-indicator-inset")) || 0;
    }

    function updateNavIndicator(activeItem, animate) {
      var navRect;
      var itemRect;
      var inset;
      var width;
      var x;

      if (!navIndicator || !activeItem) {
        return;
      }

      navRect = nav.getBoundingClientRect();
      itemRect = activeItem.getBoundingClientRect();
      inset = getNavIndicatorInset();
      width = Math.max(0, itemRect.width - inset * 2);
      x = nav.scrollLeft + (itemRect.left - navRect.left) + inset;

      if (!animate) {
        navIndicator.classList.add("apps-page__nav-indicator--no-transition");
      }

      navIndicator.style.width = width + "px";
      navIndicator.style.transform = "translateX(" + x + "px)";
      navIndicator.classList.add("is-visible");

      if (!animate) {
        navIndicator.offsetHeight;
        navIndicator.classList.remove("apps-page__nav-indicator--no-transition");
      }
    }

    function centerActiveNavItem(activeItem, behavior) {
      var navRect;
      var itemRect;
      var target;
      var max;

      if (!nav || !activeItem) {
        return;
      }

      navRect = nav.getBoundingClientRect();
      itemRect = activeItem.getBoundingClientRect();
      target = nav.scrollLeft + (itemRect.left - navRect.left) - (navRect.width - itemRect.width) / 2;
      max = nav.scrollWidth - nav.clientWidth;
      target = Math.max(0, Math.min(target, max));

      if (Math.abs(target - nav.scrollLeft) < 1) {
        return;
      }

      nav.scrollTo({
        left: target,
        behavior: behavior || (reducedMotion ? "auto" : "smooth")
      });
    }

    function setActiveNav(sectionId, options) {
      var activeItem = getNavItemForSectionId(sectionId);
      var shouldAnimateIndicator = !(options && options.animateIndicator === false);
      var navBehavior = options && options.navBehavior ? options.navBehavior : (reducedMotion ? "auto" : "smooth");
      var shouldCenter = !(options && options.skipCenter === true);
      var shouldForceUpdate = !!(options && options.force);

      if (!activeItem) {
        return;
      }

      if (activeSectionId === sectionId && !shouldForceUpdate) {
        return;
      }

      activeSectionId = sectionId;

      navItems.forEach(function (item) {
        item.classList.toggle("is-active", item === activeItem);
      });

      updateNavIndicator(activeItem, shouldAnimateIndicator);

      if (shouldCenter) {
        centerActiveNavItem(activeItem, navBehavior);
      }
    }

    function getMostRelevantSection() {
      var anchor = window.scrollY + Math.min(window.innerHeight * 0.35, 320);
      var bestSection = null;
      var bestDistance = Infinity;

      sections.forEach(function (section) {
        var top = getScrollOffset(section);
        var bottom = top + Math.max(section.offsetHeight, 1);
        var distance = 0;

        if (anchor < top) {
          distance = top - anchor;
        } else if (anchor > bottom) {
          distance = anchor - bottom;
        }

        if (distance < bestDistance) {
          bestDistance = distance;
          bestSection = section;
        }
      });

      return bestSection;
    }

    function syncActiveSection() {
      // While a programmatic scroll is in flight, leave the clicked nav item
      // active. Recomputing relevance from scrollY here would flicker the
      // highlight through every section the smooth scroll passes over.
      if (performance.now() < programmaticScrollUntil) {
        return;
      }

      var activeSection = getMostRelevantSection();

      if (!activeSection) {
        return;
      }

      setActiveNav(activeSection.id, {
        navBehavior: reducedMotion ? "auto" : "smooth"
      });
    }

    function requestSyncActiveSection() {
      if (syncFrame) {
        return;
      }

      syncFrame = window.requestAnimationFrame(function () {
        syncFrame = null;
        syncActiveSection();
      });
    }

    ensureNavIndicator();

    navItems.forEach(function (item) {
      item.addEventListener("click", function (event) {
        var target = document.querySelector(item.getAttribute("href"));

        if (!target) {
          return;
        }

        event.preventDefault();

        var targetTop = getScrollOffset(target);

        // Lock the active highlight on the clicked item until the smooth scroll
        // ends (cleared by `scrollend` below; this is the fallback ceiling).
        programmaticScrollUntil = performance.now() + 1500;

        setActiveNav(target.id, {
          force: true,
          navBehavior: getTapNavCenterBehavior()
        });

        window.scrollTo({
          top: targetTop,
          behavior: reducedMotion ? "auto" : "smooth"
        });

        if (typeof item.blur === "function") {
          item.blur();
        }
      });
    });

    window.addEventListener("scroll", requestSyncActiveSection, { passive: true });

    window.addEventListener("scrollend", function () {
      programmaticScrollUntil = 0;
      requestSyncActiveSection();
    });

    window.addEventListener("resize", function () {
      requestSyncActiveSection();

      if (activeSectionId) {
        setActiveNav(activeSectionId, {
          animateIndicator: false,
          force: true,
          navBehavior: "auto"
        });
      }
    });

    // If the user scrolls manually during a programmatic scroll, release the lock
    // so active-section detection resumes immediately.
    ["wheel", "touchstart"].forEach(function (eventName) {
      window.addEventListener(eventName, function (event) {
        if (programmaticScrollUntil <= performance.now()) {
          return;
        }

        if (event.target && typeof event.target.closest === "function" && event.target.closest("[data-app-nav]")) {
          return;
        }

        programmaticScrollUntil = 0;
      }, { passive: true });
    });

    requestSyncActiveSection();
  }

  Array.prototype.slice.call(document.querySelectorAll("[data-app-carousel]")).forEach(function (carousel) {
    var track = carousel.querySelector("[data-carousel-track]");
    var slides = Array.prototype.slice.call(carousel.querySelectorAll(".apps-carousel__slide"));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll("[data-carousel-dot]"));
    var activeIndex = 0;
    var autoplayTimer = null;
    var idleTimer = null;
    var scrollTimer = null;
    var isHovering = false;
    var isInteracting = false;
    var autoplayDelay = 3600;
    var idleDelay = 7000;

    if (!track || slides.length <= 1) {
      return;
    }

    function setActive(index) {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle("is-active", dotIndex === activeIndex);
      });
    }

    function scrollToSlide(index, behavior) {
      var targetIndex = (index + slides.length) % slides.length;
      track.scrollTo({
        left: targetIndex * track.clientWidth,
        behavior: behavior || "smooth"
      });
      setActive(targetIndex);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearTimeout(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function scheduleAutoplay() {
      stopAutoplay();

      if (reducedMotion || isHovering || isInteracting) {
        return;
      }

      autoplayTimer = window.setTimeout(function () {
        scrollToSlide(activeIndex + 1, "smooth");
        scheduleAutoplay();
      }, autoplayDelay);
    }

    function markInteracted() {
      isInteracting = true;
      stopAutoplay();

      if (idleTimer) {
        window.clearTimeout(idleTimer);
      }

      idleTimer = window.setTimeout(function () {
        isInteracting = false;
        scheduleAutoplay();
      }, idleDelay);
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener("click", function () {
        markInteracted();
        scrollToSlide(index, "smooth");
      });
    });

    track.addEventListener("scroll", function () {
      if (scrollTimer) {
        window.clearTimeout(scrollTimer);
      }

      scrollTimer = window.setTimeout(function () {
        var width = track.clientWidth || 1;
        setActive(Math.round(track.scrollLeft / width));
      }, 80);
    }, { passive: true });

    ["pointerdown", "touchstart", "wheel"].forEach(function (eventName) {
      track.addEventListener(eventName, markInteracted, { passive: true });
    });

    track.addEventListener("keydown", markInteracted);

    carousel.addEventListener("mouseenter", function () {
      isHovering = true;
      stopAutoplay();
    });

    carousel.addEventListener("mouseleave", function () {
      isHovering = false;
      scheduleAutoplay();
    });

    carousel.addEventListener("focusin", function () {
      isHovering = true;
      stopAutoplay();
    });

    carousel.addEventListener("focusout", function () {
      isHovering = false;
      scheduleAutoplay();
    });

    setActive(0);
    scheduleAutoplay();
  });
});
